module.exports = __webpack_public_path__ + "static/media/7.59037d4f.jpg";